import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './lib/posthog' // Initialize PostHog

createRoot(document.getElementById("root")!).render(<App />);
